// extracted by mini-css-extract-plugin
export default {"page_wrap":"CompanyProfile_page_wrap__v6750"};